import styled from "styled-components";
import * as Variable from "../../CSSVariables";

export const ContinueShoppingStyle = styled.div`
  @media only screen and (min-width: ${Variable.tablet}) {
     {
      margin-top: 30px;
    }
  }
  a {
    color: ${Variable.scienceBlue};
    &:hover {
      text-decoration: underline;
    }

    font-size: 0;
    @media only screen and (min-width: ${Variable.tablet}) {
      font-size: 1.6rem;
    }
    img {
      vertical-align: middle;
      margin-right: 6px;
    }
  }
`;
